import React from 'react';

import { useHistory } from 'react-router-dom';

import TableHeader from '../../../../../components/Table/TableHeader';
import TablePagination from '../../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../../components/InputSearch'

const tabelaColunas = ['Data / Hora', 'Usuário', 'Arquivo', 'Total', 'OK', 'Aviso', 'Duplicado', 'Erro', 'Status']

const ListOportunidadeLog = ({
    response,
    mudarPagina,
    exportarLogOportunidade
}) => {
    const history = useHistory();

    const changePage = (page) => {
        mudarPagina(page);
    }

    const gotoDet = (idOportunidade) => {
        history.push(`/oportunidade/editar/${idOportunidade}`);
    }

    return (
        <div className="produtos-lista">
            <div className="row">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table table-sm table-striped">
                            <TableHeader columns={tabelaColunas} />
                            <tbody>
                                {(!response?.lista || response?.lista.length === 0) && (
                                    <tr>
                                        <td colSpan={tabelaColunas.length}> Sem Registros </td>
                                    </tr>
                                )}
                                {response?.lista && response?.lista.map((data, i) => (
                                    <tr key={i}>
                                        <td>{data.dataHoraImportacao}</td>
                                        <td>{data.usuario}</td>
                                        <td>{data.nomeArquivo}</td>
                                        <td style={{ cursor: 'pointer' }} onClick={() => exportarLogOportunidade(1, data.id)}>{data.totalRegistroArquivo}</td>
                                        <td style={{ cursor: 'pointer' }} onClick={() => exportarLogOportunidade(0, data.id)}>{data.totalRegistroSucesso}</td>
                                        <td style={{ cursor: 'pointer' }} onClick={() => exportarLogOportunidade(2, data.id)}>{data.totalRegistroAviso}</td>
                                        <td style={{ cursor: 'pointer' }} onClick={() => exportarLogOportunidade(3, data.id)}>{data.totalRegistroDuplicado}</td>
                                        <td style={{ cursor: 'pointer' }} onClick={() => exportarLogOportunidade(4, data.id)}>{data.totalRegistroErro}</td>
                                        <td>{data.status}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <TablePagination data={response} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ListOportunidadeLog;